<template>
  <div class="doctor_scheduling">
    <div class="menu_list">
      <el-menu class="menu" :default-active="activeIndex" mode="horizontal" @select="handleSelect">
        <!-- <el-menu-item index="shift">班次管理</el-menu-item> -->
        <!-- <el-menu-item index="register">挂号设置</el-menu-item> -->
        <el-menu-item index="schedule">日常排班</el-menu-item>
        <!-- <el-menu-item index="stop">停诊设置</el-menu-item> -->
        <!-- <el-menu-item index="free">义诊设置</el-menu-item> -->
      </el-menu>
    </div>
    <div class="content">
      <components :is="componentMap[activeIndex]" :doctorOptions="['register', 'stop', 'free'].includes(activeIndex) ? doctorOptions : {}"></components>
    </div>
  </div>
</template>

<script lang="js">
import Shift from "./Shift.vue";
import Register from "./Register.vue";
import Schedule from "./Schedule.vue";
import Stop from "./Stop.vue";
import Free from "./Free.vue";
export default {
  name: "Scheduling",
  components: { Shift, Register, Schedule, Stop, Free},
  data() {
    return {
      activeIndex: "schedule",
      componentMap: {
        'shift':  Shift,
        'register': Register,
        'schedule': Schedule,
        'stop': Stop,
        'free': Free,
      },
      doctorOptions: []
    }
  },
  created() {
    let index = this.$session.get('scheduleIndex')
    if (index) {
      this.activeIndex = index;
    }
    this.$getDoctorOptions({ type: 0, status: 0 }); // 获取所有馆内在职医生
  },
  methods:{
    // 切换当前显示组件
    handleSelect(key) {
      this.activeIndex = key;
      this.$session.set('scheduleIndex', key);
    }
  }
};
</script>

<style lang="less" scoped>
  .doctor_scheduling {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
  }

  .menu_list {
    width: 100%;
    height: 56px;
  }

  .menu {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }

  .menu_list /deep/.el-menu--horizontal>.el-menu-item {
    box-sizing: border-box;
    height: 56px;
    line-height: 56px;
  }

  .content {
    width: 100%;
    height: calc(100% - 56px);
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>
